import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=5fc50dc0&scoped=true&"
import script from "./change_password.vue?vue&type=script&lang=js&"
export * from "./change_password.vue?vue&type=script&lang=js&"
import style0 from "./change_password.vue?vue&type=style&index=0&id=5fc50dc0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc50dc0",
  null
  
)

export default component.exports